<template>
  <div class="wrapper" id="uploader">
    <br />
    <div class="btns_group">
      <div class="select_file btn default" id="browse">選擇檔案</div>
      <div
        class="upload_btn btn success"
        id="start-upload"
        @click="startUpload"
      >
        開始上傳
      </div>
      <div class="upload_btn btn success" id="start-upload" @click="clearFiles">
        重新選擇
      </div>
    </div>
    <!-- <div class="horizen_splitLine"></div> -->
    <div class="selectedFiles">
      <!-- 動態渲檔案列表 -->
      <div class="file_row" v-for="(item, index) in fileList" :key="index">
        <span>{{ item.name }}</span>
        <span>{{ (item.size / 1024 / 1024).toFixed(2) + "MB" }}</span>
        <span>{{ item.percent != 0 ? item.percent + "%" : "" }}</span>
      </div>
    </div>
  </div>
</template>
<script>
// 導入plupload插件庫
import plupload from 'plupload'
export default {
  props: [
    'url', // 檔案上傳請求地址
    'mime_types', // 要上傳檔案類型
    'max_file_size', // 單檔案大小上限
    'params' // 檔案之外的附加參數
  ],

  data () {
    return {
      pluploadObj: undefined, // plupload檔案上傳插件對象
      fileList: [] // 已選擇檔案列表
    }
  },
  methods: {
    /**
     * 執檔案上傳操作
     */
    startUpload () {
      this.pluploadObj && this.pluploadObj.files.length > 0
        ? this.pluploadObj.start()
        : this.$emit('whenUpload', { msg: 'plupload happened error!' })
    },
    /**
     * 重新選檔案-清檔案列表
     */
    clearFiles () {
      if (this.pluploadObj && this.fileList && this.fileList.length > 0) {
        // 清檔案列表
        let _that = this
        this.fileList.some(function (value, index, array) {
          _that.pluploadObj.removeFile(value)
        })
        this.fileList.splice(0, this.fileList.length)
      }
    },
    /**
     *檔案上傳成功時的回調函數
     *
     */
    callBack (uploader, file, responseObject) {
      // 自定義事件檔案上傳成功之後-接收服務器端返回值
      this.$emit('successCallBackLater', uploader, file, responseObject)
    },
    errorCallBack (uploader, error) {
      // 自定義事件檔案上傳發生錯誤時-自定義處理方式
      this.$emit('errorCallBackLater', uploader, error)
    }
  },
  mounted () {
    let _that = this
    // plupload插件參數配置
    let pluploadConfig = {
      browse_button: 'browse', // 檔案上傳按鈕
      url: this.$props.url, // 檔案請求接口
      filters: {
        // 檔案類型過濾器-默認支持所檔案類型
        mime_types: this.$props.mime_types
          ? this.$props.mime_types
          : 'image/*,audio/*,video/*,text/*,application/zip',
        // 單檔案大小定義
        max_file_size: this.$props.max_file_size
          ? this.$props.max_file_size + 'mb'
          : '0', // 默認0-無上限
        // 防檔案重複選擇
        prevent_duplicates: true, // default-false
        multipart: true, // default -true ,是否檔案作為 multipart/form-data (default) 或者binary stream上傳
        drop_element: 'drag-area', // 拖拽方式選檔案
        multi_selection: true, // 開啟檔案上傳
        unique_names: true, // 為每檔案自動生成唯一名稱-作為額外的參數post到服務器端，參數名為name,值為生成檔案名
        chunk_size: '1Mb' // 檔案分塊大小
      },
      init: {
        // 檔案上傳之前的回調函數
        BeforeUpload: function (up, files) {
          up.setOption('multipart_params', _that.$props.params)
        },
        // 添檔案時的回調函數
        FilesAdded: function (up, files) {
          // var html = "";
          plupload.each(files, function (file) {
            // 記錄當前選中檔案-Vue組件自動刷新-無需定制
            _that.fileList.push(file)
          })
        },
        // 檔案上傳時的進度條綁定
        UploadProgress: function (up, file) {
          // 已經封裝到Vue組件中-自動刷新-無須定制
        },
        /**
         * uploader為當前的plupload實例對象，file為觸發此事件檔案對象，responseObject為服務器返回的信息對象，它有以下3個屬性：
         *          response：服務器返回的文本
         *          responseHeaders：服務器返回的頭信息
         *          status：服務器返回的http狀態碼，比如200
         */
        FileUploaded: function (uploader, file, responseObject) {
          // 回調函數處理
          _that.callBack(uploader, file, responseObject)
        },
        // 錯誤處理回調函數
        Error: function (up, err) {
          // 回調函數處理
          _that.errorCallBack(up, err)
        }
      }
    }
    // 初始化plupload插件
    this.pluploadObj = new plupload.Uploader(pluploadConfig)
    // 調用初始化方法
    this.pluploadObj.init()
  }
}
</script>
<style scoped>
.wrapper {
  width: 450px;
  border: 1px solid #ccc;
  border-radius: 5%;
  background-color: #ffffff;
}
.default {
  background-color: #409eff;
}
.success {
  background-color: #67c23a;
}
.btn {
  color: #ffffff;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 10%;
}
.btns_group {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

/*檔案上传列表样式 */
.filelist {
  list-style: none;
}
.selectedFiles {
  margin: 15px 5px;
  border-top: 1px solid #ccc;
}
.selectedFiles .file_row {
  padding: 10px 5px;
}
.selectedFiles img {
  margin-left: 5px;
}
.selectedFiles span {
  margin: 5px 10px;
}
#drag-area {
  border: 1px solid #ccc;
  height: 150px;
  line-height: 150px;
  text-align: center;
  color: #aaa;
  width: 400px;
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadFile.vue